import {  makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonClose: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    '&:hover': {
      backgroundColor: 'rgba(215, 222, 233, 0.5)',
    },
  },
  iconClose: {
    width: '18px',
    height: '18px',
    color: '#4F4F4F',
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
    rowGap: '10px',
    padding: '0.5rem 1rem',
    overflowY: 'scroll',
  },
  quantityField: {
    maxWidth: '9.375rem'
  },
  trashButton: {
    width: '24px',
    minWidth: '24px',
    height: '24px',
    padding: 0,
    marginLeft: '0.625rem',
    backgroundColor: 'var(--color-red-opacity-10)',
    color: 'var(--color-red)',
    '& > span': {
      justifyContent: 'center',
    },
    '&:hover' : {
      backgroundColor: 'var(--color-red-opacity-25)',
    }
  },
  button: {
    background: '#329BFC',
    color: '#fff',
    width: 200,
    height: 40,
    alignSelf: 'center',
    transition: 'filter 0.2s',
    marginTop: '0.625rem',
    '&:hover': {
      background: '#329BFC',
      filter: 'brightness(0.9)'
    },
    '&:disabled': {
      opacity: 0.5,
      color: '#fff'
    }
  },
  cancelButton: {
    background: '#f64444',
    color: '#fff',
    width: 200,
    height: 40,
    alignSelf: 'center',
    transition: 'filter 0.2s',
    '&:hover': {
      background: '#f64444',
      filter: 'brightness(0.9)'
    },
    '&:disabled': {
      opacity: 0.5,
      color: '#fff'
    }
  }
}));